import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, Stack, Typography } from '@mui/material';

// project imports
import MainCard from '../../../../Components/MainCard';
import Dot from '../../../../Components/@extended/Dot';
import Avatar from '../../../../Components/@extended/Avatar';
import { ThemeMode } from '../../../../config';
import {formatDistanceToNow} from "date-fns";

const avatarImage = require.context('../../../../assets/images/users', true);

// ==============================|| KANBAN BACKLOGS - STORY COMMENT ||============================== //

const StoryComment = ({ comment, profile }) => {
  const theme = useTheme();

  return (
    <MainCard
      content={false}
      sx={{
        background: "#fafafa",
        p: 1.5,
        mt: 1.25
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid container wrap="nowrap" alignItems="center" spacing={1}>
            {/*<Grid item>*/}
            {/*  <Avatar*/}
            {/*    sx={{ width: 24, height: 24 }}*/}
            {/*    size="sm"*/}
            {/*    alt="User 1"*/}
            {/*    src={profile && profile.avatar && avatarImage(`./${profile.avatar}`)}*/}
            {/*  />*/}
            {/*</Grid>*/}
            <Grid item xs zeroMinWidth>
              <Grid container alignItems="center" spacing={1} justifyContent="space-between">
                <Grid item>
                  <Typography align="left" variant="subtitle1" component="div">
                    {comment.username}
                  </Typography>
                </Grid>
                <Grid item>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Dot size={6} sx={{ mt: -0.25 }} color="secondary" />
                    <Typography variant="caption" color="secondary">
                      {formatDistanceToNow(new Date(parseInt(comment.update_epoch*1000)), {addSuffix: true})}
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ '&.MuiGrid-root': { pt: 1.5 } }}>
          <Typography align="left" variant="body2">
            {comment.comment}
          </Typography>
        </Grid>
      </Grid>
    </MainCard>
  );
};
StoryComment.propTypes = {
  comment: PropTypes.object,
  profile: PropTypes.object
};
export default StoryComment;
